import $ from 'jquery';

export default {
  handle_reposition_callback(response) {
    for (const release of response.releases) {
      $(`.release-feature-list[data-release-id='${release}'] li.card`)
        .not('.placeholder, .card--placeholder')
        .each((i, element) => {
          const idAttr = $(element).attr('id');
          const featureId = idAttr.replace('feature_', '').replace('epic_', '');
          const newPosition = response.features[featureId];
          $(element)
            .attr('data-feature-position', newPosition)
            .attr('data-release-id', release);
        });
    }
  },

  register_reposition_confirmation_cancel_handler: releaseIds => {
    // When the confirmation modal is closed via the modal header X,
    // force a reactive update on the elements representing the
    // applicable releases so they revert to their original state.
    $('#modal-window')
      .find('.close')
      .one('click', function (event) {
        for (const releaseId of releaseIds) {
          const releaseElements = $(
            `[data-release-id='${releaseId}'][data-reactive-url]`
          ).toArray();
          for (const element of releaseElements) {
            const $element = $(element);
            const url = $element.attr('data-reactive-url');
            window.reactor.forceUpdateElement($element, url);
          }
        }
      });
  },
};
